import { clsModel, fnCreate } from '@cls/clsModel'

////////////////////////////////////////////////////////////////////////////////////////////////////
//
// This model is a helper model which is not used for data manipulation but to
// help create an appointment for one or more employees.
// 
////////////////////////////////////////////////////////////////////////////////////////////////////

var modelName = "workorder_createappointment";
const fields = [
    'id_employees', 
    'dt',
    'from',
    'to',
];

class clsCreateAppointment extends clsModel {

    id_employees = null;
    dt = null;
    from = null;
    to = null;

    async save() {
        return this.toJSON();
    }        
    async doCreate(defaults) {
        defaults = defaults || {};
        defaults.id_employees = defaults.id_employees || [];
        defaults.from = defaults.from || 8 * 60; // default from 8:00

        // Estimate can be more than 24 hours. Lets limit it to 8 hours.
        // If the user wants more, he can change it afterwards.
        var duration = Math.min(defaults.estimate || 8*60, 8*60);
        defaults.to = defaults.from + duration;
        return super.doCreate(defaults);
    }

    constructor() {
        super({
          api: {},   
          modelName: modelName, 

          fillable: fields
        })
    } 
        
 }
 export default fnCreate(clsCreateAppointment , 'clsCreateAppointment');
